import script from "./WholePieceReadcode.vue?vue&type=script&setup=true&lang=js"
export * from "./WholePieceReadcode.vue?vue&type=script&setup=true&lang=js"

import "./WholePieceReadcode.vue?vue&type=style&index=0&id=6d83dde8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d83dde8"]])

export default __exports__